var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_7070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07304 20.3749C5.15604 20.5799 5.96604 22.4139 8.83604 23.7829C9.33404 24.0199 9.93204 23.8099 10.169 23.3109C10.407 22.8119 10.196 22.2159 9.69704 21.9779C9.03204 21.6609 8.51604 21.3199 8.12004 20.9989H23.878C23.481 21.3209 22.966 21.6609 22.302 21.9779C21.803 22.2159 21.593 22.8119 21.83 23.3109C22.068 23.8099 22.665 24.0209 23.163 23.7829C25.991 22.4339 26.833 20.5959 26.92 20.3909C27.024 20.1469 27.026 19.8699 26.926 19.6249C26.843 19.4199 26.033 17.5859 23.163 16.2169C23.024 16.1509 22.877 16.1189 22.733 16.1189C22.36 16.1189 22.002 16.3289 21.83 16.6879C21.592 17.1869 21.803 17.7829 22.302 18.0209C22.967 18.3379 23.483 18.6789 23.88 18.9999H8.12104C8.51704 18.6779 9.03304 18.3379 9.69704 18.0209C10.196 17.7829 10.406 17.1869 10.169 16.6879C9.99804 16.3289 9.63904 16.1179 9.26604 16.1189C9.12104 16.1189 8.97504 16.1499 8.83604 16.2169C6.00804 17.5659 5.16604 19.4039 5.07904 19.6089C4.97504 19.8529 4.97304 20.1299 5.07304 20.3749Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_7070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.ad4eadc93def65bc670d2101f1f703c4.svg";
export { ForwardRef as ReactComponent };